import { combineReducers } from "redux";

import {
    RECEIVE_UTU_SUSPECTS,
    SELECT_UTU_SUSPECT,
    SET_UTU_SUSPECT_SEARCH_QUERY_FILTER,
    EXIT_CURRENT_DASHBOARD,
    SET_UTU_SUSPECT_DATE_FILTER,
    SET_TOTAL_UTU_COUNT,
} from "redux/actions";

function data(state = [], action) {
    if (action.type === RECEIVE_UTU_SUSPECTS) {
        state = action.utu_suspects;
    }
    return state;
}

function selectedSuspect(state = {}, action) {
    if (action.type === SELECT_UTU_SUSPECT) {
        state = action.uid;
    }
    if (action.type === EXIT_CURRENT_DASHBOARD) {
        state = {};
    }
    return state;
}

function searchQueryFilter(state = "", action) {
    if (action.type === SET_UTU_SUSPECT_SEARCH_QUERY_FILTER) {
        state = action.searchQuery;
    }
    return state;
}

function dateFilter(state = { from: null, to: null }, action) {
    if (action.type === SET_UTU_SUSPECT_DATE_FILTER) {
        state = action.dates;
    }
    return state;
}

function count(state = 0, action) {
    if (action.type === SET_TOTAL_UTU_COUNT) {
        state = action.count;
    }
    return state;
}

const utuSuspects = combineReducers({
    data,
    count,
    selectedSuspect,
    searchQueryFilter,
    dateFilter,
});

export default utuSuspects;
